import React from 'react';
import {ScrollView, View} from 'react-native';
import {noop} from 'lodash';

import LastChangeDateComponent from '/component/partial/LastChangeDateComponent';
import {COACH_PROFILE} from '/enum/recordType.enum';

import Contact from './Contact';
import CreditsAndRewards from './CreditsAndRewards';
import Details from './Details';
import NextPremierOrder from './NextPremierOrder';
import Notes from './Notes';
import OrderHistory from './OrderHistory';
import {styles} from './ProfileTab.style';

interface ProfileTabProps {
  coachId: number;
  recordId: number | null;
  featureFlag: {
    showCoachAndClientNotes?: boolean;
  };
  onShowRecord: (args: {recordType: string; recordId: number}) => void;
  onOrderPress: (order: any) => void;
  onViewMoreOrderHistory: () => void;
  onShowContactActions: () => void;
  navigate: (route: string) => void;
  removeExpiringRewards: boolean;
}

export const ProfileTab: React.FC<ProfileTabProps> = ({
  coachId = 0,
  recordId = null,
  featureFlag = {showCoachAndClientNotes: false},
  onShowRecord = noop,
  onOrderPress = noop,
  onViewMoreOrderHistory = noop,
  navigate = noop,
  removeExpiringRewards = false,
}) => (
  <ScrollView
    style={styles.base}
    contentContainerStyle={styles.contentContainer}>
    <View style={styles.content}>
      <Contact coachId={coachId} />
      <Details
        coachId={coachId}
        onBusinessCoachPress={({businessCoachId}: any) =>
          onShowRecord({recordType: COACH_PROFILE, recordId: businessCoachId})
        }
      />
      {featureFlag.showCoachAndClientNotes && (
        <Notes
          coachId={recordId}
          disabled={true}
          greyOutTextInputValue={false}
          onPress={() => navigate('coach-notes-edit-screen')}
          FooterComponent={LastChangeDateComponent}
          showEditNotesLabel={true}
        />
      )}
      <NextPremierOrder coachId={coachId} />
      {!removeExpiringRewards && <CreditsAndRewards coachId={coachId} />}
      <OrderHistory
        coachId={coachId}
        onOrderPress={onOrderPress}
        onViewMore={onViewMoreOrderHistory}
      />
    </View>
  </ScrollView>
);

export default ProfileTab;
